import { axiosPrivate } from '../hooks/axiosPrivate';

const upload = (file,product_id, onUploadProgress) => {
  let formData = new FormData();

  formData.append("avatar", file); 
  formData.append("productid", product_id); 
console.log(formData);

  return axiosPrivate.post("/excursionproductimage/createproductsimages", formData, {
    headers: {
        "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

const getFiles = () => {
  return axiosPrivate.get("/files");
};

const FileUploadApi = {
  upload,
  getFiles,
};

export default FileUploadApi; 